import { useTempDataContext } from '@fox/atoms';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { useEffect, useState } from 'react';
import { PaymentAddComponentProps } from '../../../contracts';
import { useFormPaymentContext } from '../../form-payment-context';
import useLatest from 'use-latest';

/**
 * Component for forms to display a PayPal button for payment.
 * PayPal buttons handles the transaction and the intent needs to contain the amount, therefore we have to update the intent with the amount every time the total payment amount changes.
 * Complete intent creates a credit card in financial backend that cannot be charged to store references for the payment, those are used when creating and verifying the receipt.
 */
export function PayPalOneTimePayment({ completeIntent, settings, updateIntent, intentData }: PaymentAddComponentProps) {
	var clientId = settings?.['clientId'];
	const { grandTotal, submitForm } = useFormPaymentContext();
	const tempData = useTempDataContext();
	const [loading, setLoading] = useState<boolean>(false);

	//due to the internal structure of PayPalButtons, the submitfunction is stale when we submit (without using useLatest)
	const submitFormLatest = useLatest(submitForm);

	useEffect(() => {
		const update = async () => {
			if (updateIntent && grandTotal > 1) {
				setLoading(true);
				await updateIntent(intentData?.intentId, grandTotal);
				setLoading(false);
			}
		};
		update();
	}, [grandTotal]);

	return (
		<PayPalScriptProvider options={{ clientId, intent: 'authorize', currency: 'AUD', disableFunding: ['card', 'credit'] }}>
			<div style={{ minWidth: '20rem', margin: '0 auto' }}>
				<PayPalButtons
					disabled={grandTotal === 0 || (tempData && tempData.cardFormDataValid === true) || loading}
					style={{ disableMaxWidth: true }}
					onApprove={async (data, actions) => {
						const acres = await completeIntent(
							intentData.intentId,
							JSON.stringify({
								orderId: data.orderID,
								paymentId: data.paymentID,
								payerId: data.payerID
							})
						);

						if (tempData) tempData.cardFormDataValid = true;

						submitFormLatest.current?.(acres);
					}}
					createOrder={(data, actions) => Promise.resolve(intentData?.intentId)} //we can just pass in the intentId (orderId) we created on the backend
				/>
			</div>
		</PayPalScriptProvider>
	);
}
